// Diff mode tab strip (Split / Overlay / Processes / Documents) — the review
// tab hoists it into the TopBar's active-tab slot, ahead of that tab's lifecycle
// buttons, so the view selector comes first. Reads from and writes to the shared
// diffModeStore so the strip stays in sync with DiffBoard (which drives the
// actual board).
import { useDiffMode, setDiffMode, type DiffMode } from "@archlang/app-shell/workbench";
import { SegmentedControl } from "@archlang/ui";

const DIFF_MODE_TABS: { id: DiffMode; label: string }[] = [
  { id: "split", label: "Split" },
  { id: "overlay", label: "Overlay" },
  { id: "processes", label: "Processes" },
  { id: "documents", label: "Documents" },
];

export { setDiffMode };

export function DiffModeTabStrip() {
  const mode = useDiffMode();
  return (
    <SegmentedControl
      label="Diff view mode"
      items={DIFF_MODE_TABS}
      active={mode}
      onSelect={setDiffMode}
      // e2e addresses the tabs by `[data-mode]`.
      itemProps={(id) => ({ "data-mode": id })}
    />
  );
}
